import { useState, useEffect } from "react";

const TypingAnimation = ({ text, speed = 50, chunkSize = 3 }) => {
  const [displayText, setDisplayText] = useState("");

  useEffect(() => {
    if (!text) return;

    let i = 0;
    let timer;

    const animate = () => {
      if (i < text.length) {
        let chunk = text.substring(i, Math.min(i + chunkSize, text.length));
        setDisplayText((prev) => prev + chunk);
        i += chunkSize;
        timer = setTimeout(animate, speed);
      }
    };

    timer = setTimeout(animate, speed);

    return () => clearTimeout(timer);
  }, [text, speed, chunkSize]);

  return <span>{displayText}</span>;
};

export default TypingAnimation;